/**
 * 直播相关接口
 * Filename: live.js
 * Author: GaoYu
 * Time: 2020/7/14 14:55
 */
import request from "@/utils/request";
export function PdfImgword(params) {
  return request({
    url: "/api/v5/monthly/get-magazine-img-info",
    method: "get",
    params
  });
}
export function getLiveDocumentApi(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/document/getDetail",
    method: "get",
    params
  });
}

export function getLiveDetailApi(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/live/getH5LiveDetail",
    method: "get",
    params
  });
}

export function getNewLiveDetailApi(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/live/getH5Detail",
    method: "get",
    params
  });
}

export function getLiveShareApi(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/live/liveH5Share",
    method: "get",
    params
  });
}

export function titleFrameContent(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/live/titleFrameContent",
    method: "get",
    params
  });
}

export function liveIsNeedAppointApi(params) {
  return request({
    url: process.env.API_DY_BASE_URL + "live/v1/live/getLiveBeforeUrlH5",
    method: "get",
    params
  });
}

export function getAlbumInfoApi(params) {
  return request({
    url: "h5/share/getAlbumInfo",
    method: "get",
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/live.js